/* Opt-in data-oi-submit-dots en button o enlace; AJAX (Rails UJS) limpia estado. */

var __OI_DOT_CLS = 'is-submitting-oi-dots';

function resetOiDotsOne(el) {
  if (el && el.nodeType === 1) el.classList.remove(__OI_DOT_CLS);
}

function resetOiDotsAllBound() {
  document.querySelectorAll('[data-oi-submit-dots].' + __OI_DOT_CLS).forEach(resetOiDotsOne);
}

function oiDotsEligible(el) {
  if (!el || el.nodeType !== 1) return false;
  if (typeof el.closest === 'function' && el.closest('fieldset[disabled]')) return false;
  if (el.getAttribute('aria-disabled') === 'true') return false;
  var tag = el.tagName || '';
  if (tag === 'BUTTON' || tag === 'INPUT') return !el.disabled;
  return tag === 'A';
}

function oiDotsAjaxCleanup(ev) {
  var t = ev.target;
  if (!t || t.nodeType !== 1) return;
  var cand =
    (typeof t.closest === 'function'
      ? t.closest('[data-oi-submit-dots]') ||
        (t.closest('form') && t.closest('form').querySelector('[data-oi-submit-dots]'))
      : null);
  resetOiDotsOne(cand);
}

function oiDotsOnFormInvalid(ev) {
  var t = ev.target;
  var form = t && t.form;
  if (!form) return;
  form.querySelectorAll('[data-oi-submit-dots]').forEach(resetOiDotsOne);
  if (form.id && /^[a-zA-Z][\w.-]*$/.test(form.id)) {
    document
      .querySelectorAll('[data-oi-submit-dots][form="' + form.id + '"]')
      .forEach(resetOiDotsOne);
  }
}

document.addEventListener(
  'pointerdown',
  function (ev) {
    var el =
      ev.target && typeof ev.target.closest === 'function'
        ? ev.target.closest('[data-oi-submit-dots]')
        : null;
    if (!oiDotsEligible(el)) return;
    el.classList.add(__OI_DOT_CLS);
  },
  true
);

document.addEventListener('ajax:complete', oiDotsAjaxCleanup);
document.addEventListener('ajax:error', oiDotsAjaxCleanup);
document.addEventListener('invalid', oiDotsOnFormInvalid, true);

function bindJqAjaxOiDots() {
  var $jq = typeof window !== 'undefined' && window.jQuery;
  if (!$jq) return;
  var $doc = $jq(document);
  $doc.off('.ajaxOiDots');
  $doc.on('ajax:complete.ajaxOiDots ajax:error.ajaxOiDots', oiDotsAjaxCleanup);
}

bindJqAjaxOiDots();

if (!window.__oiSubmitDotsHistBound) {
  window.__oiSubmitDotsHistBound = true;
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) resetOiDotsAllBound();
  });
  document.addEventListener('turbolinks:load', function () {
    bindJqAjaxOiDots();
    resetOiDotsAllBound();
  });
}

window.oiSubmitDotsReset = resetOiDotsOne;
window.oiSubmitDotsResetAll = resetOiDotsAllBound;
